<template>
  <Posts :object="object" :params="params" :key="version" />
</template>

<script>
import {defineComponent, onMounted, ref} from "vue"
import Posts from "@/modules/post/pages/posts/components/posts/Posts"
import Default from "@/modules/post/pages/posts/services/PostsNotModerated"

export default defineComponent({
  name: "PostsSiteNotModerated",
  components: {
    Posts
  },
  setup() {
    let version = ref(0)
    let object = new Default()

    function getChannelId() {
      return 1
    }

    let params = {
      title: "Посты на модерацию",
      h1: "Посты на модерацию",
      page: "posts_not_moderated",
      type_ids: [6, 7, 8, 9, 10, 12, 13, 14],
      channel_id: getChannelId(),
    }

    onMounted(() => {
      version.value++
    })

    return {
      object,
      params,
      version,
    }
  }
})
</script>

<style scoped>

</style>
